export default __webpack_public_path__ + "static/media/hitachi.685f791c.png";